/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import { canOptimizeImageHost } from "@/lib/storeImage";

type StoreImageProps = {
  src?: string | null;
  alt: string;
  className?: string;
  /** Diteruskan ke next/image saat host dioptimasi. */
  sizes?: string;
  /** Eager-load (kandidat LCP). */
  priority?: boolean;
  /** Isi penuh kontainer relatif (object-cover). */
  fill?: boolean;
  /** Wajib saat !fill. */
  width?: number;
  height?: number;
};

/**
 * Gambar storefront tahan-banting: optimasi `next/image` untuk host yang kita
 * kontrol, fallback `<img>` untuk host eksternal arbitrer agar tak pernah rusak.
 */
export function StoreImage({
  src,
  alt,
  className,
  sizes,
  priority = false,
  fill = false,
  width,
  height,
}: StoreImageProps) {
  if (!src) return null;

  if (canOptimizeImageHost(src)) {
    return fill ? (
      <Image src={src} alt={alt} fill sizes={sizes} priority={priority} className={className} />
    ) : (
      <Image
        src={src}
        alt={alt}
        width={width ?? 0}
        height={height ?? 0}
        sizes={sizes}
        priority={priority}
        className={className}
      />
    );
  }

  // Host eksternal arbitrer → <img> langsung (tak butuh remotePatterns).
  const loading = priority ? "eager" : "lazy";
  const fetchPriority = priority ? "high" : undefined;
  return fill ? (
    <img
      src={src}
      alt={alt}
      loading={loading}
      fetchPriority={fetchPriority}
      className={`absolute inset-0 h-full w-full ${className ?? ""}`.trim()}
    />
  ) : (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      fetchPriority={fetchPriority}
      className={className}
    />
  );
}
